



































import { mapGetters, mapState } from 'vuex'
import { format } from '~/utils/date'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import ClassifiedStatsService from '~/services/classified/stats/ClassifiedStatsService'
import { PriceChange } from '~/models/classified/stats'
import { CategoryId } from '~/models/category/types'
import { defineComponent } from '@nuxtjs/composition-api'
import SubscriptionPerksBadge from '~/components/car/subscriptions/SubscriptionPerksBadge.vue'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import CCardTitle from '~/components/shared/configurable/card/CCardTitle.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { USER_NS } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: {
    ApexChart: () => import('vue-apexcharts'),
    SubscriptionPerksBadge,
    CCardHeader,
    CCardTitle,
    CCard
  },
  data() {
    return {
      currentPrice: null,
      minPrice: null,
      maxPrice: null,
      changes: null,
      tier: null
    }
  },
  updated() {
    this.$emit('updated')
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classified.id,
      categoryIds: state => state.classified.category_ids
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin',
      userCanViewPriceStats: 'userCanViewPriceStats'
    }),
    categorySupportsPriceChangesStats() {
      return (
        this.categoryIds.includes(CategoryId.VEHICLES) ||
        this.categoryIds.includes(CategoryId.XYMA)
      )
    },
    priceChangesChartIsSupported() {
      return (
        this.userCanViewPriceStats && this.categorySupportsPriceChangesStats
      )
    },
    showPriceChangesChart() {
      return (
        this.priceChangesChartIsSupported &&
        (this.changes === null || (this.changes && this.changes.length > 1))
      )
    },
    chartSeries() {
      return [
        {
          name: this.$t('price'),
          data: this.changes.map((change: PriceChange) => change.price)
        }
      ]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          height: 350,
          type: 'area',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.8,
            opacityTo: 0.6,
            stops: [0, 90, 100]
          }
        },

        xaxis: {
          labels: {
            show: false
          },
          tooltip: {
            enabled: false
          },
          categories: this.changes.map((change: PriceChange) =>
            format(change.date)
          )
        }
      }
    }
  },
  async mounted() {
    if (!this.priceChangesChartIsSupported) {
      return
    }

    try {
      const classifiedStatsService = this.$dep(ClassifiedStatsService)

      const {
        maxPrice,
        minPrice,
        currentPrice,
        changes,
        tier
      } = await classifiedStatsService.getPriceStats(this.classifiedId)
      this.maxPrice = maxPrice
      this.minPrice = minPrice
      this.currentPrice = currentPrice
      this.changes = changes
      this.tier = tier
    } catch (error) {
      if (!error.response) {
        this.$logger.captureError(error as any)
      }
      this.changes = []
    }
  }
})
